'use client';
import React, { useEffect } from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import ChatList from './ChatList';
import ChatWindow from './ChatWindow';
import { initializeChatStore, useChatStore } from './useChat';
import { Roles } from '../ClientProfiles/Roles.types';
import { useSupabaseAuth } from './useSupabaseAuth';

const CustomerSupportPage: React.FC = () => {
	const { isLoading: authLoading } = useSupabaseAuth(
		`${Roles.CUSTOMER_SUPPORT},${Roles.KOGNI_ADMIN}`
	);
	const { isLoading, error } = useChatStore();

	useEffect(() => {
		if (!authLoading) {
			initializeChatStore();
		}
	}, [authLoading]);

	if (authLoading || isLoading) {
		return (
			<div className="flex justify-center items-center h-screen">
				<div className="spinner"></div>
			</div>
		);
	}

	if (error) {
		return (
			<div className="p-8">
				<Typography color="error" size="sm">
					{error}
				</Typography>
			</div>
		);
	}

	return (
		<div className="h-screen w-full bg-white">
			<div className="h-full flex">
				<div className="w-80 flex-shrink-0 border-r border-gray-200">
					<ChatList />
				</div>

				<div className="flex-1 flex">
					<ChatWindow />
				</div>
			</div>
		</div>
	);
};

export default CustomerSupportPage;
